<template>
    <div>
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('ircasemaintenance.irstaffcasemaintenancelist'),
            dataHeader: [
                { text: this.$t('payeeinputprocess.action'),  value: 'action',  width: '100px', sortable: false},
                { text: this.$t('ircasemaintenance.caseid'), value: 'caseid', width: '200px' }, 
                { text: this.$t('recdisciplinaryrec.casedesc'), value: 'shortdesc', width: '200px' }, 
            ],

            dataItems: [],
            getId: [],
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {

        loadCaseSubList() {
            const vm = this;

            this.$store.dispatch('get', {url: '/casesubmaintenance/all'})
            .then (res => {
                vm.dataItems = res.data.rec;
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            })
        },

        editItemHandler(item) {
            this.$router.push({name: 'casesubmaintenanceedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'casesubmaintenancenew'});
        }
    },

    mounted() {
        this.loadCaseSubList()
    }
}
</script>